import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    mediaUrl: '',
    title: '',
    description: '',
    cta: [],
    type: 1,
  },
};

export const splashSlice = createSlice({
  name: 'splash',
  initialState,
  reducers: {
    splashStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent } = block;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.blockContent = {
        mediaUrl: blockContent.mediaUrl ?? '',
        title: blockContent.title ?? '',
        description: blockContent.description ?? '',
        cta: blockContent.cta ?? [],
        type: 1,
      };
    },
    splashClear: () => initialState,

    splashUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    splashUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    splashUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const { splashStore, splashClear, splashUpdateIsLoading, splashUpdateIsActive, splashUpdateBlockContent } = splashSlice.actions;

export const selectSplashIsLoading = (state) => state.splash.isLoading;
export const selectSplashIsActive = (state) => state.splash.isActive;

export const selectSplashId = (state) => state.splash.id;
export const selectSplashIsAdded = (state) => Boolean(state.splash.id);
export const selectSplashUID = (state) => state.splash.uid;
export const selectSplashSID = (state) => state.splash.sid;

export const selectSplashBlockContent = (state) => state.splash.blockContent;

export default splashSlice.reducer;
